/**
 * Format unit enum
 * ---
 * Non-integrated unit keys
 * @enum string
 * @readonly
 *
 * @see https://github.com/unicode-org/cldr/blob/master/common/validity/unit.xml
 */
export const E_Format_UnitCustom = {
	POWER_KILOWATT: "power-kilowatt",
	POWER_KILOWATT_PER_HOUR: "power-kilowatt-per-hour",
	ELECTRIC_VOLT: "electric-volt",
	ELECTRIC_AMPERE: "electric-ampere",
	PERCENT: "PERCENT",
};

/**
 * Format unit enum
 * @enum string
 * @readonly
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat Number format unit options
 * @see https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-issanctionedsimpleunitidentifier A list of units that was selected for use in ECMAScript.
 * @see https://github.com/unicode-org/cldr/blob/master/common/validity/unit.xml Full list of all units (includes not supported by ECMAScript which must be implemented separately **@see E_Format_UnitCustom**).
 * @see E_Format_UnitCustom Enum of unsupported units by the ECMAScript
 */
export const E_Format_Unit = {
	ACRE: "acre",
	BIT: "bit",
	BYTE: "byte",
	CELSIUS: "celsius",
	CENTIMETER: "centimeter",
	DAY: "day",
	DEGREE: "degree",
	FAHRENHEIT: "fahrenheit",
	FLUID_OUNCE: "fluid-ounce",
	FOOT: "foot",
	GALLON: "gallon",
	GIGABIT: "gigabit",
	GIGABYTE: "gigabyte",
	GRAM: "gram",
	HECTARE: "hectare",
	HOUR: "hour",
	INCH: "inch",
	KILOBIT: "kilobit",
	KILOBYTE: "kilobyte",
	KILOGRAM: "kilogram",
	KILOMETER: "kilometer",
	LITER: "liter",
	MEGABIT: "megabit",
	MEGABYTE: "megabyte",
	METER: "meter",
	MILE: "mile",
	MILE_SCANDINAVIAN: "mile-scandinavian",
	MILLILITER: "milliliter",
	MILLIMETER: "millimeter",
	MILLISECOND: "millisecond",
	MINUTE: "minute",
	MONTH: "month",
	OUNCE: "ounce",
	PERCENT: "percent",
	PETABYTE: "petabyte",
	POUND: "pound",
	SECOND: "second",
	STONE: "stone",
	TERABIT: "terabit",
	TERABYTE: "terabyte",
	WEEK: "week",
	YARD: "yard",
	YEAR: "year",
	...E_Format_UnitCustom,
};
